import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';
import * as uiActions from './actions';
import * as userActions from '../user/actions';
import { version } from '../../../package.json';

const initialState = {
    device: 'mobile', // either desktop or mobile
    version: version,
    redirectPath: '/',
};

export const uiReducer = (state = initialState, action) => {
    switch (action.type) {
        case uiActions.SET_DEVICE:
            return {
                ...state,
                device: action.device,
            };

        case uiActions.SET_VERSION:
            return {
                ...state,
                version: action.version,
            };

        case uiActions.SET_REDIRECT_PATH:
            return {
                ...state,
                redirectPath: action.path,
            };

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 32+++');
            return {
                ...state,
                version: version,
            };

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 36+++');
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/ui/reducer.js